module.exports = __webpack_public_path__ + "media/detection.990834ec.mp3";